import React, {useEffect} from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import tickImg from "../../assets/images/icons/tick-circle.png"

const ServiceBenifits = ({data}) => {
    useEffect(() => {
        AOS.init({
            once:false,
        });
      }, [])


  return (

        <section className='service-benifits'>
            <div className='container'>
                <div className='top-head'>
                    <h2 className='ttl1'>Benefits</h2>
                </div>
                <div className='benefits-wrap-list'>
                {
                    data.map((response, index) =>{
                        return(
                            <div className='list-itm' key={index}>
                                <img src={tickImg} alt='' />
                                <p>{response.benifitCont}</p>
                            </div>
                        )
                    })
                }
                    
                </div>
            </div>
        </section>
  )
}

export default ServiceBenifits